<template>
  <v-dialog
      max-width="800px"
      v-model="dialog"
  >
    <v-card elevation="0" flat tile>
      <v-col class="text-right px-4">
        <v-btn icon @click="dialog=false; elevatorId = null" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>

      <v-card-text>
        <v-row justify="space-around">
          <v-col>
            <h2 class="primary--text font-weght-bold pt-5 pl-2">
              <v-icon color="primary" large left>
              </v-icon>
              {{ $t('display/elevator:overview.update') }}
            </h2>

            <TwoButtonDialog
              ref="updateSoftware"
              :outlined="true"
              :rounded="false"
              :icon="'system_update'"
              :btn-text="$t('display/elevator:edit.labels.functions-tab.update-software')"
              color="primary"
              :dialog-title="$t('display/elevator:edit.labels.functions-tab.update-software')"
              :dialog-text="$t('display/elevator:edit.dialog.update-software-text')"
              :button1-text="$t('buttons:cancel')"
              :button2-text="$t('display/elevator:edit.dialog.send')"
              @clickedButton1="$refs.updateSoftware.showDialog = false"
              @clickedButton2="makeUpdateSoftware()"
            />

            <TwoButtonDialog
              ref="updatePlaylist"
              :outlined="true"
              :rounded="false"
              :icon="'list'"
              :btn-text="$t('display/elevator:edit.labels.functions-tab.update-playlist')"
              color="primary"
              :dialog-title="$t('display/elevator:edit.labels.functions-tab.update-playlist')"
              :dialog-text="$t('display/elevator:edit.dialog.update-playlist')"
              :button1-text="$t('buttons:cancel')"
              :button2-text="$t('display/elevator:edit.dialog.send')"
              @clickedButton1="$refs.updatePlaylist.showDialog = false"
              @clickedButton2="makeUpdatePlaylist()"
            />

            <TwoButtonDialog
              ref="updateWether"
              :outlined="true"
              :rounded="false"
              :icon="'device_thermostat'"
              :btn-text="$t('display/elevator:edit.labels.functions-tab.update-weather')"
              color="primary"
              :dialog-title="$t('display/elevator:edit.labels.functions-tab.update-weather')"
              :dialog-text="$t('display/elevator:edit.dialog.update-weather-text')"
              :button1-text="$t('buttons:cancel')"
              :button2-text="$t('display/elevator:edit.dialog.send')"
              @clickedButton1="$refs.updateWether.showDialog = false"
              @clickedButton2="makeUpdateWether()"
            />
          </v-col>
        </v-row>

        <v-row justify="space-around">
          <v-col>
            <h2 class="primary--text font-weght-bold pt-5 pl-2">
              <v-icon color="primary" large left>
              </v-icon>
              {{ $t('buttons:download') }}
            </h2>

            <TwoButtonDialog
              ref="downloadLogFile"
              :outlined="true"
              :rounded="false"
              :icon="'notes'"
              :btn-text="$t('display/elevator:edit.labels.functions-tab.download-logfile')"
              color="primary"
              :dialog-title="$t('display/elevator:edit.labels.functions-tab.download-logfile')"
              :dialog-text="$t('display/elevator:edit.dialog.download-logfile-text')"
              :button1-text="$t('buttons:cancel')"
              :button2-text="$t('display/elevator:edit.dialog.send')"
              @clickedButton1="$refs.downloadLogFile.showDialog = false"
              @clickedButton2="downloadLogFile()"
            />

            <TwoButtonDialog
              ref="downloadMotionLog"
              :outlined="true"
              :rounded="false"
              :icon="'notes'"
              :btn-text="$t('display/elevator:edit.labels.functions-tab.download-motion-logs')"
              color="primary"
              :dialog-title="$t('display/elevator:edit.labels.functions-tab.download-motion-logs')"
              :dialog-text="$t('display/elevator:edit.dialog.download-motion-logs-text')"
              :button1-text="$t('buttons:cancel')"
              :button2-text="$t('display/elevator:edit.dialog.send')"
              @clickedButton1="$refs.downloadMotionLog.showDialog = false"
              @clickedButton2="downloadMotionLog()"
            />
          </v-col>
        </v-row>

        <v-row justify="space-around">
          <v-col>
            <h2 class="primary--text font-weght-bold pt-5 pl-2">
              <v-icon color="primary" large left>
              </v-icon>
              {{ $t('display/elevator:overview.critical') }}
            </h2>

            <TwoButtonDialog
              ref="deleteElevator"
              :outlined="true"
              :rounded="false"
              :icon="'delete_forever'"
              :btn-text="$t('display/elevator:edit.labels.functions-tab.delete-elevator')"
              color="red"
              :dialog-title="$t('display/elevator:edit.labels.functions-tab.delete-elevator')"
              :dialog-text="$t('display/elevator:edit.dialog.delete-elevator-text')"
              :button1-text="$t('buttons:cancel')"
              :button2-text="$t('buttons:delete')"
              @clickedButton1="$refs.deleteElevator.showDialog = false"
              @clickedButton2="deleteElevator()"
            />

            <TwoButtonDialog
              ref="restartApp"
              :outlined="true"
              :rounded="false"
              :icon="'computer'"
              :btn-text="$t('display/elevator:edit.labels.functions-tab.restart-view-app')"
              color="red"
              :dialog-title="$t('display/elevator:edit.labels.functions-tab.restart-view-app')"
              :dialog-text="$t('display/elevator:edit.dialog.restart-view-app-text')"
              :button1-text="$t('buttons:cancel')"
              :button2-text="$t('display/elevator:edit.dialog.send')"
              @clickedButton1="$refs.restartApp.showDialog = false"
              @clickedButton2="restartApp()"
            />

            <TwoButtonDialog
              ref="restartDevice"
              :outlined="true"
              :rounded="false"
              :icon="'power_settings_new'"
              :btn-text="$t('display/elevator:edit.labels.functions-tab.restart-device')"
              color="red"
              :dialog-title="$t('display/elevator:edit.labels.functions-tab.restart-device')"
              :dialog-text="$t('display/elevator:edit.dialog.restart-device-text')"
              :button1-text="$t('buttons:cancel')"
              :button2-text="$t('display/elevator:edit.dialog.send')"
              @clickedButton1="$refs.restartDevice.showDialog = false"
              @clickedButton2="restartDevice()"
            />
          </v-col>
        </v-row>

        <v-row justify="space-around">
          <v-col>
            <h2 class="primary--text font-weght-bold pt-5 pl-2">
              <v-icon color="primary" large left>
              </v-icon>
              {{ $t('display/elevator:overview.data') }}
            </h2>

            <TwoButtonDialog
              ref="importData"
              :outlined="true"
              :rounded="false"
              :icon="'import_export'"
              :btn-text="$t('buttons:import')"
              color="primary"
              :add-text-field="true"
              :add-text-field-label="$t('display/elevator:edit.dialog.insert-elevator-id')"
              :dialog-title="$t('display/elevator:edit.labels.functions-tab.import-title')"
              :button1-text="$t('buttons:cancel')"
              :button2-text="$t('display/elevator:edit.dialog.send')"
              @clickedButton1="$refs.importData.showDialog = false"
              @clickedButton2="importData()"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>

import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog';
import ElevatorService from '@/modules/display/services/elevator-service';
import Utils from '@/modules/core/services/utils';

export default {
  name: "ElevatorFunctionsForm",
  components: {
    TwoButtonDialog
  },
  data() {
    return {
      dialog: false,
      elevatorId: null
    }
  },
  methods: {
    initialization(elevatorId) {
      this.elevatorId = elevatorId;
      this.$nextTick(() => {
        this.dialog = true;
      });
    },

    makeUpdateSoftware() {
      this.sendCommand('update');
      this.$refs.updateSoftware.showDialog = false;
    },

    makeUpdatePlaylist(){
      this.sendCommand('playlist');
      this.$refs.updatePlaylist.showDialog = false;
    },

    makeUpdateWether() {
      this.sendCommand('weather');
      this.$refs.updateWether.showDialog = false;
    },

    downloadLogFile() {
      this.sendCommandWithBody("getlogs")
      this.$refs.downloadLogFile.showDialog = false;
    },

    downloadMotionLog() {
      this.sendCommandWithBody("getmotionlogs")
      this.$refs.downloadMotionLog.showDialog = false;
    },

    deleteElevator() {
      ElevatorService.remove(
          this.elevatorId,
        () => {
          Utils.showSuccessSnackbar(this.$t('display/elevator:edit.dialog.success-send'));
          this.$store.commit('display/elevatorForm/closeWindow');
        },
        () => {
          Utils.showFailureSnackbar(this.$t('display/elevator:edit.dialog.problem-happened'));
        }
      );
      this.$refs.deleteElevator.showDialog = false;
    },

    restartApp() {
      this.sendCommandWithBody("restart")
      this.$refs.restartApp.showDialog = false;
    },

    restartDevice() {
      this.sendCommandWithBody("reboot")
      this.$refs.restartDevice.showDialog = false;
    },

    importData() {
      ElevatorService.importSettings(
          this.elevatorId,
        this.$refs.importData.textField,
        () => {
          Utils.showSuccessSnackbar(this.$t('display/elevator:edit.dialog.success-send'));
          this.dialog = false;
          this.$emit('updateTable');
        },
        () => {
          Utils.showFailureSnackbar(this.$t('display/elevator:edit.dialog.problem-happened'));
        }
      );
      this.$refs.importData.showDialog = false;
    },

    sendCommand(command) {
      ElevatorService.sendCommand(
          this.elevatorId,
          command,
          () => {
            Utils.showSuccessSnackbar(this.$t('display/elevator:edit.dialog.success-send'));
          },
          () => {
            Utils.showFailureSnackbar(this.$t('display/elevator:edit.dialog.problem-happened'));
          }
      );
    },

    sendCommandWithBody(command) {
      ElevatorService.sendCommandWithBody(
          this.elevatorId,
          {'cmd' : command},
          () => {
            Utils.showSuccessSnackbar(this.$t('display/elevator:edit.dialog.success-send'));
          },
          () => {
            Utils.showFailureSnackbar(this.$t('display/elevator:edit.dialog.problem-happened'));
          }
      );
    }

  },

}
</script>

<style scoped>

</style>
